export default (superclass) => class extends superclass {
    findByPayrollItem(payrollItem, options) {
        const id = (typeof payrollItem === 'string') ?
            payrollItem : payrollItem.id;

        return new this.constructor(this.filter(model => {
            return (model.get('payrollItemId') === id);
        }), options);
    }

    findByType(type) {
        if (typeof type !== 'string') {
            return new this.constructor(null, {});
        }

        return this.findByTypes([type]);
    }

    findByTypes(types) {
        return new this.constructor(this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (payrollItem && _.contains(types, payrollItem.get('type')));
        }), {});
    }

    findAdditions() {
        const additions =  this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (
                payrollItem &&
                _.contains(
                    ['addition', 'bonus', 'base', 'overtime'],
                    payrollItem.get('type')
                ) &&
                (payrollItem.get('isGross') || payrollItem.get('isNet'))
            );
        })
        return new this.constructor(additions.sort((x, y) => {
            return x.getPayrollItem().get('name') === 'Salary (Basic)' ? -1 :
                y.getPayrollItem().get('name') === 'Salary (Basic)' ? 1 : 0;
        }), {});
    }

    findBenefits() {
        return new this.constructor(this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (
                payrollItem &&
                payrollItem.get('type') === 'benefit' &&
                payrollItem.get('affectsMtd') === true &&
                !payrollItem.get('isGross') &&
                !payrollItem.get('isNet')
            );
        }), {});
    }

    findBenefitsNonTaxable() {
        return new this.constructor(this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (
                payrollItem &&
                payrollItem.get('type') === 'benefit' &&
                payrollItem.get('affectsMtd') === false &&
                !payrollItem.get('isGross') &&
                !payrollItem.get('isNet')
            );
        }), {});
    }

    findDeductions() {
        return new this.constructor(this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (
                payrollItem && (
                    payrollItem.get('type') === 'mtd' || (
                        _.contains(
                            [
                                'unpaid_leave',
                                'deduction',
                                'mtd',
                                'epf',
                                'socso',
                                'cp38',
                                'zakat',
                                'eis',
                                'hrdf'
                            ],
                            payrollItem.get('type')
                        ) && (
                            payrollItem.get('isGross') ||
                                payrollItem.get('isNet')
                        )
                    )
                )
            );
        }), {});
    }

    findTaxDeductions() {
        return new this.constructor(this.filter(model => {
            const payrollItem = model.getPayrollItem();

            return (
                payrollItem &&
                (
                    (
                        payrollItem.get('type') === 'deduction' &&
                        payrollItem.get('affectsMtd') === true
                    ) ||
                    payrollItem.get('type') === 'zakat'
                ) &&
                !payrollItem.get('isGross') &&
                !payrollItem.get('isNet')
            );
        }), {});
    }
};



// WEBPACK FOOTER //
// ./app/new-collections/mixins/payroll-item-filters.js